import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart, ShoppingBag } from "lucide-react";
import { toast } from "sonner";
import { api, imgUrl } from "@/lib/api";
import { euro } from "@/lib/shop";
import { HeartButton } from "@/components/HeartButton";
import { Spinner } from "@/components/ProtectedRoute";
import { useWishlist } from "@/context/WishlistContext";
import { useCart } from "@/context/CartContext";
import { useShopSettings } from "@/context/ShopSettingsContext";
import { TikTokShopButton } from "@/components/TikTokShopButton";

export default function Wishlist() {
  const { ids } = useWishlist();
  const { add } = useCart();
  const { showcase_mode } = useShopSettings();
  const [items, setItems] = useState(null);

  useEffect(() => {
    if (!ids.length) return setItems([]);
    api.get("/products/by-ids", { params: { ids: ids.join(",") } }).then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, [ids]);

  if (!items) return <Spinner />;
  return (
    <div className="mx-auto max-w-4xl px-4 pt-6 sm:px-6">
      <h1 className="text-3xl font-extrabold tracking-tight">Preferiti</h1>
      {items.length === 0 ? (
        <div data-testid="wishlist-empty" className="card-mc mt-6 px-6 py-14 text-center">
          <Heart className="mx-auto h-10 w-10" />
          <div className="mt-3 font-display text-lg font-extrabold">Nessun preferito</div>
          <p className="mt-1 text-sm text-muted-foreground">Tocca il cuore su un articolo per salvarlo qui.</p>
          <Link to="/" className="btn-mc mt-5">Vai al catalogo</Link>
        </div>
      ) : (
        <div data-testid="wishlist-list" className="mt-5 space-y-3">
          {items.map((p) => (
            <div key={p.id} data-testid={`wishlist-item-${p.id}`} className="card-mc flex items-center gap-3 p-3">
              <Link to={`/prodotto/${p.id}`} className="h-20 w-20 shrink-0 overflow-hidden rounded-xl border border-border bg-white">
                {p.images?.[0] && <img src={imgUrl(p.images[0])} alt="" className="h-full w-full object-contain" />}
              </Link>
              <div className="min-w-0 flex-1">
                <Link to={`/prodotto/${p.id}`} className="line-clamp-2 text-sm font-bold">{p.name}</Link>
                {!showcase_mode && <div className="mt-0.5 font-display font-extrabold">{euro(p.price)}</div>}
                {p.quantity <= 0 && <div className="text-xs font-bold text-red-600">Esaurito</div>}
              </div>
              <HeartButton id={p.id} className="h-9 w-9 shrink-0" />
              {showcase_mode ? (
                p.quantity > 0 && <TikTokShopButton product={p} size="sm" label="TikTok Shop" testId={`wishlist-tiktok-button-${p.id}`} placement="wishlist" />
              ) : (
              <button data-testid={`wishlist-add-to-cart-${p.id}`} className="btn-mc !h-9 !px-3" disabled={p.quantity <= 0}
                onClick={() => { add(p); toast.success("Aggiunto al carrello"); }}>
                <ShoppingBag className="h-4 w-4" /> <span className="hidden sm:inline">Aggiungi</span>
              </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
